import { useQuery } from '@tanstack/react-query';
import { fetchDoctors } from '../api';

export const getQueryKey = (applicationId: number, taskId: number) => {
  return ['doctors', applicationId, taskId];
};

const useDoctors = (applicationId: number, taskId: number, enabled = true) => {
  const { isLoading, data, refetch } = useQuery({
    queryKey: getQueryKey(applicationId, taskId),
    queryFn: () => fetchDoctors(applicationId, taskId),
    enabled,
    refetchOnWindowFocus: false,
  });

  return {
    doctors: data ?? [],
    isLoading: enabled ? isLoading : false,
    refetch, // Expose refetch function for manual refresh
  };
};

export default useDoctors;
